import type { ViewerManifest } from "./viewer/types";

// Live Mint-generated relic GLBs (generated 2026-07-16, account renzochain@gmail.com).
// Artifact URLs are durable CDN links returned by get_asset_artifact_manifest.
export const assetManifest = {
  kind: "model",
  title: "Relik Bootcamp",
  activeItemId: "ai_agent",
  items: [
    {
      id: "ai_agent",
      title: "Relik Hermes AI Agent",
      glbUrl:
        "https://cdn.mint.gg/glb/obsidian-halo-core-normalized-40372406493af756.glb",
      thumbnailUrl: "",
      prompt: "A floating crystalline AI core relic",
    },
    {
      id: "forex_xau",
      title: "Relik Mech All-Terrain",
      build: "mech",
      accent: "#d9a441",
      thumbnailUrl: "",
      prompt: "A battle mech relic",
    },
    {
      id: "crypto",
      title: "Relik Crypto Research",
      glbUrl:
        "https://cdn.mint.gg/glb/amethyst-chain-monolith-normalized-a279d04d525d730f.glb",
      thumbnailUrl: "",
      prompt: "A cracked geode stone crypto relic",
    },
    {
      id: "bundle",
      title: "Relik Bundle",
      glbUrl:
        "https://cdn.mint.gg/glb/pearlescent-mint-reliquary-normalized-656ea7c625137e61.glb",
      thumbnailUrl: "",
      prompt: "A treasure-ark relic",
    },
    {
      id: "robot_hermes",
      title: "Robot Hermes",
      build: "hermes",
      accent: "#3da9ff",
      thumbnailUrl: "",
      prompt: "A humanoid AI agent robot",
    },
    {
      id: "robot_crypto",
      title: "Drone Crypto",
      build: "crypto",
      accent: "#a16bff",
      thumbnailUrl: "",
      prompt: "A floating crypto drone robot",
    },
    {
      id: "robot_content",
      title: "Bot Content AI",
      build: "content",
      accent: "#d9a441",
      thumbnailUrl: "",
      prompt: "A marketing robot with megaphone",
    },
    {
      id: "robot_umkm",
      title: "Bot UMKM",
      build: "umkm",
      accent: "#3fbf8f",
      thumbnailUrl: "",
      prompt: "A helper robot on wheels",
    },
    {
      id: "robot_mech",
      title: "Mech Sentinel",
      build: "mech",
      accent: "#8fd0ff",
      thumbnailUrl: "",
      prompt: "A sentinel mech robot",
    },
  ],
} satisfies ViewerManifest;
